export var injectSWRCache = function (cache, watcher) {
    // intercept operations modifying the cache store
    var originalSet = cache.set;
    cache.set = function (key, value) {
        watcher(key, value);
        return originalSet.call(cache, key, value);
    };
    var originalDelete = cache.delete;
    cache.delete = function (key) {
        watcher(key, undefined);
        return originalDelete.call(cache, key);
    };
};
export var isMetaCache = function (key) {
    return /^\$(?:req|err|ctx|len)\$/.test(key);
};
export var isInfiniteCache = function (key) {
    return /^\$inf\$/.test(key);
};
export var getInfiniteCacheKey = function (key) {
    var _a, _b;
    var match = key.match(/^\$inf\$(?<cacheKey>.*)?/);
    return (_b = (_a = match === null || match === void 0 ? void 0 : match.groups) === null || _a === void 0 ? void 0 : _a.cacheKey) !== null && _b !== void 0 ? _b : key;
};
//# sourceMappingURL=swr-cache.js.map